<template>
  <div class="edit-company float-right">
    <b-modal 
      id="new-company"
      ref="editCompanyRef"
      :hide-header="true"
      size="md">
      <form id="edit-company-form">
        <h5 class="my-5">公司信息</h5>
        <div class="form-group row">
          <label for="company-code" class="col-2 col-form-label col-form-label-sm">公司代码</label>
          <div class="col-4">
            <input name="company-code" class="form-control form-control-sm input" :readonly="!this.isCreateNew" v-model="company.company_code" placeholder="zhifubao" type="text" v-validate="'required'" :class="{'is-invalid': errors.has('company-code')}">
          </div>
          <label for="nickname" class="col-2 col-form-label col-form-label-sm">公司简称</label>
          <div class="col-4">
            <input name="nickname" class="form-control form-control-sm input" v-model="company.nickname" type="text" v-validate="'required'" :class="{'is-invalid': errors.has('nickname')}">
          </div>
        </div>

        <div class="form-group row">
          <label for="company-name" class="col-2 col-form-label col-form-label-sm">公司全称</label>
          <div class="col-10">
              <input name="company-name" class="input form-control form-control-sm" v-model="company.company_name" placeholder="xxx网络科技有限公司" type="text" v-validate="'required'" :class="{'is-invalid': errors.has('company-name')}">
          </div>
        </div>

        <h5 class="my-5">发货信息</h5>
        <div class="form-group row">
          <label for="sender-name" class="col-2 col-form-label col-form-label-sm">发货人</label>
          <div class="col-4">
            <input name="sender-name" class="form-control input form-control-sm" v-model="company.sender_name" type="text" v-validate="'required'" :class="{'is-invalid': errors.has('sender-name')}">
          </div>
          <label for="sender-phone" class="col-2 col-form-label col-form-label-sm">发货人电话</label>
          <div class="col-4">
            <input name="sender-phone" placeholder="15858123456" class="form-control form-control-sm input" v-model="company.sender_phone" type="text" v-validate="'required'" :class="{'is-invalid': errors.has('sender-phone')}">
          </div>
        </div>
        <div class="form-group row">
          <label for="sender-address" class="col-2 col-form-label col-form-label-sm">发货地址</label>
          <div class="col-10">
            <input name="sender-address" class="form-control form-control-sm input" v-model="company.sender_address" placeholder="浙江省|杭州市|西湖区|余杭塘路803号冠苑双子座804" type="text" v-validate="'required'" :class="{'is-invalid': errors.has('sender-address')}">
          </div>
        </div>

        <h5 class="my-5">FTP/后台帐号(第三方公司使用公司代码+FTP密码登录)</h5>
        <div class="form-group row">
          <label for="ftp-host" class="col-2 col-form-label col-form-label-sm">服务器地址</label>
          <div class="col-4">
              <input name="ftp-host" class="form-control form-control-sm input" v-model="company.ftp_host" placeholder="ftp.example.com" type="text">
          </div>
          <label for="xml-root" class="col-2 col-form-label col-form-label-sm">xml目录</label>
          <div class="col-4">
              <input name="xml-root" class="form-control form-control-sm input" v-model="company.xml_root" placeholder="/" type="text">
          </div>
        </div>
        <div class="form-group row">
          <label for="ftp-username" class="col-2 col-form-label col-form-label-sm">用户名</label>
          <div class="col-4">
            <input name="ftp-username" placeholder="jianxiang" v-model="company.ftp_username" class="form-control form-control-sm input" type="text">
          </div>
          <label for="ftp-password" class="col-2 col-form-label col-form-label-sm">密码</label>
          <div class="col-4">
            <input name="ftp-password" class="form-control form-control-sm input" v-model="company.ftp_password" type="text" v-validate="'required'" :class="{'is-invalid': errors.has('ftp-password')}">
          </div>
        </div>

        <h5 class="my-5">对账</h5>
         <div class="form-group row">
           <label for="ftp-username" class="col-2 col-form-label col-form-label-sm">信用额度</label>
            <div class="col-4">
              <div class="input-group input-group-sm">
                <input name="credits" placeholder="jianxiang" v-model="company.meta.credits" class="form-control input" type="text" v-validate="{ required: true, min_value:0 }" :class="{'is-invalid': errors.has('credits')}">
                <div class="input-group-append">
                  <span class="input-group-text">元</span>
                </div>
              </div>
            </div>
         </div>

      </form>
      <div slot="modal-footer" class="w-100">
        <button class="btn btn-primary float-right mx-5" @click="editCompany">提交</button>
        <button class="btn btn-secondary float-right" @click="$refs.editCompanyRef.hide();">取消</button>
     </div>
    </b-modal>
  </div>

</template>

<script>
function editCompany (company) {
  let form = document.getElementById('edit-company-form')
  var object = {}
  new FormData(form).forEach(function (value, key) {
    object[key.replace(/-/g, '_')] = value
  })

  // validate form
  this.$validator.validateAll().then((result) => {
    if (!result) {
      return
    }

    let url = '/api/companies/' + this.company.company_code
    if (this.isCreateNew) {
      url = '/api/companies'
    }
    this.$http.put(url, object).then(response => {
      this.$refs.editCompanyRef.hide()
      this.$emit('refresh')
    })
  })
}

function showEditCompanyModal (company, isCreateNew) {
  this.isCreateNew = isCreateNew
  this.company = company
  this.$refs.editCompanyRef.show()
}

export default {
  name: 'exit-company',
  data () {
    return {
      company: { meta: {} },
      isCreateNew: false
    }
  },
  components: {
  },
  methods: {
    editCompany,
    showEditCompanyModal
  }
}

</script>